import "./Projects.scss";
import { ProjectsIcon, SearchIcon, ExternalLinkIcon, AddIcon, CalendarIcon, DollarIcon, UserIcon } from "../../../../../shared/cockpit/components/icons/Icon";

interface ProjectData {
  id: string;
  name: string;
  objectName: string;
  status: "PLANNING" | "EXECUTION" | "COMPLETED";
  timeline: {
    start: string;
    end: string;
  };
  budget: string;
  manager: string;
}

const projectsData: ProjectData[] = [
  {
    id: "PRJ1",
    name: "Retrofit Ladeinfrastruktur & PV",
    objectName: "FitX Berlin-Alexanderplatz",
    status: "PLANNING",
    timeline: { start: "01.05.2026", end: "31.08.2026" },
    budget: "150.000 €",
    manager: "A. Bauer",
  },
  {
    id: "PRJ2",
    name: "Schnelllader-Installation",
    objectName: "Casino Royal Dortmund",
    status: "EXECUTION",
    timeline: { start: "01.02.2026", end: "20.06.2026" },
    budget: "85.000 €",
    manager: "M. Schmidt",
  },
  {
    id: "PRJ3",
    name: "Mieterstrom & Wärmepumpe",
    objectName: "Hafenquartier Hamburg",
    status: "COMPLETED",
    timeline: { start: "01.08.2025", end: "01.01.2026" },
    budget: "320.000 €",
    manager: "L. Weber",
  },
];

function Projects() {
  return (
    <div className="projects-view">
      <header className="projects-view__header">
        <div className="projects-view__header__content">
          <div className="projects-view__header__title--container">
            <div className="projects-view__header__icon-wrapper">
              <ProjectsIcon />
            </div>
            <h2 className="projects-view__header__title">Projekte</h2>
          </div>

          <p className="projects-view__header__subtitle">
            Übersicht aller laufenden und geplanten Projekte über alle
            Gesellschaften hinweg.
          </p>
        </div>
        <button className="projects-view__header__add-btn">
          <AddIcon /> Neues Projekt
        </button>
      </header>

      <div className="projects-view__content">
        <div className="projects-view__search-bar">
          <SearchIcon className="projects-view__search-icon" />
          <input type="text" placeholder="Projektname oder Manager suchen..." />
        </div>

        <div className="projects-table">
          <div className="projects-table__header">
            <div className="projects-table__col">PROJEKT & OBJEKT</div>
            <div className="projects-table__col">STATUS</div>
            <div className="projects-table__col">ZEITPLAN</div>
            <div className="projects-table__col">BUDGET</div>
            <div className="projects-table__col">MANAGER</div>
            <div className="projects-table__col text-right">AKTION</div>
          </div>

          <div className="projects-table__body">
            {projectsData.map((project) => (
              <div key={project.id} className="projects-table__row">
                <div className="projects-table__col">
                  <div className="project-info">
                    <span className="project-info__name">{project.name}</span>
                    <span className="project-info__object">
                      {project.objectName}
                    </span>
                    <span className="project-info__id">ID: {project.id}</span>
                  </div>
                </div>
                <div className="projects-table__col">
                  <span
                    className={`status-badge status-badge--${project.status.toLowerCase()}`}
                  >
                    {project.status}
                  </span>
                </div>
                <div className="projects-table__col">
                  <div className="timeline-info">
                    <CalendarIcon className="timeline-info__icon" />
                    <div className="timeline-info__text">
                      <span>Start: {project.timeline.start}</span>
                      <span>Ziel: {project.timeline.end}</span>
                    </div>
                  </div>
                </div>
                <div className="projects-table__col">
                  <div className="budget-info">
                    <DollarIcon className="budget-info__icon" />
                    <span>{project.budget}</span>
                  </div>
                </div>
                <div className="projects-table__col">
                  <div className="manager-info">
                    <UserIcon className="manager-info__icon" />
                    <span>{project.manager}</span>
                  </div>
                </div>
                <div className="projects-table__col text-right">
                  <button className="action-btn">
                    <ExternalLinkIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
